import React, { useState, useEffect } from "react";
import { Popover, TextField, Box, Button } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

type FilterPopoverProps = {
  column: any;
  setColValue: (cb: (prev: any[]) => any[]) => void;
  iconColor?: string;
};

const DateFilterPopover = ({
  column,
  setColValue,
  iconColor,
}: FilterPopoverProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedDate, setSelectedDate] = useState<string>("");
  const columnName = column.id;

  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<Element>) => {
    setAnchorEl(e.currentTarget as HTMLElement);
  };

  const handleClose = () => {
    setAnchorEl(null);
    column.setFilterValue(undefined);
    setColValue((prev: any[]) =>
      (prev || []).filter((f) => f.filterField !== column.id)
    );
    setSelectedDate("");
  };

  const handleApply = () => {
    if (selectedDate) {
      //   const filterValue = { date: selectedDate };
      const filterValue = { [columnName]: selectedDate };

      column.setFilterValue(filterValue);
      setColValue((prev: any[]) => {
        const updated = (prev || []).filter((f) => f.filterField !== column.id);
        return [...updated, { filterField: column.id, filterValue }];
      });
    }
    setAnchorEl(null);
  };

  //   useEffect(() => {
  //     const applied = column.getFilterValue();
  //     if (applied?.date) {
  //       setSelectedDate(applied.date);
  //     }
  //   }, [column]);

  useEffect(() => {
    const applied = column.getFilterValue();
    if (applied && typeof applied === "object") {
      setSelectedDate(applied[columnName] || "");
    }
  }, [column]);

  return (
    <>
      <FilterAltIcon
        fontSize="small"
        onClick={handleOpen}
        style={{ cursor: "pointer", marginLeft: 6, color: iconColor }}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} width={250}>
          <TextField
            label="Select Date"
            type="date"
            value={selectedDate}
            fullWidth
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setSelectedDate(e.target.value)}
          />

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button
              className="btn btn-secondary"
              size="small"
              variant="outlined"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              size="small"
              variant="contained"
              onClick={handleApply}
              disabled={!selectedDate}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default DateFilterPopover;
